import { Button, Alert, Stack } from '@mui/material';
import { CompanyAccessSummary, CompanySeatSummary } from '@handover/shared-types';
import { Link as RouterLink } from 'react-router-dom';
import { getWorkspaceStatusMessage, isBillingLockedStatus } from '../../helpers/companyAccessHelper';

type WorkspaceBillingBannerProps = {
  accessSummary?: CompanyAccessSummary | null;
  seatSummary?: CompanySeatSummary | null;
  supportEmail?: string;
  canManageBilling?: boolean;
};

export const WorkspaceBillingBanner = ({
  accessSummary,
  seatSummary,
  supportEmail,
  canManageBilling = false,
}: WorkspaceBillingBannerProps) => {
  if (!accessSummary) {
    return null;
  }

  const locked = isBillingLockedStatus(accessSummary);
  const billingMessage = getWorkspaceStatusMessage(accessSummary);
  const seatLimitMessage =
    seatSummary &&
    !seatSummary.unlimitedSeats &&
    accessSummary.seatLimitReached
      ? `Your workspace has reached its seat limit (${seatSummary.activeSeats}/${seatSummary.seatLimit}). Publish departures or increase seats to add more employees.`
      : null;

  if (!billingMessage && !seatLimitMessage) {
    return null;
  }

  return (
    <Alert
      severity={locked ? 'error' : 'warning'}
      sx={{ mb: 3, borderRadius: 2 }}
      action={
        <Stack direction="row" spacing={1}>
          {locked && canManageBilling ? (
            <Button component={RouterLink} to="/billing" color="inherit" size="small">
              Open Billing
            </Button>
          ) : !locked ? (
            <Button component={RouterLink} to="/support" color="inherit" size="small">
              Get Help
            </Button>
          ) : null}
          {locked && canManageBilling && supportEmail ? (
            <Button color="inherit" size="small" href={`mailto:${supportEmail}`}>
              Contact support
            </Button>
          ) : null}
        </Stack>
      }
    >
      {billingMessage || seatLimitMessage}
      {billingMessage && seatLimitMessage ? ` ${seatLimitMessage}` : ''}
    </Alert>
  );
};
